module.exports = __webpack_public_path__ + "static/media/W19-1340_Smoke_Gouda_Desktop_2396x1473.e4261ccc.jpg";